import { createSelector } from '@reduxjs/toolkit';
import { usersAdapterSelectors } from '../redux/slices/users';

const getCurrentWorkspaceUsersFromStore = (state) =>
  state.currentWorkspace.users;

export const getCurrentWorkspaceUsers = createSelector(
  getCurrentWorkspaceUsersFromStore,
  (state) => (id) => usersAdapterSelectors.selectById(state, id),
  (usersIds, getUsersById) => usersIds.map((userId) => getUsersById(userId))
);

export const getUsersWithCustomerMembership = createSelector(
  usersAdapterSelectors.selectAll,
  (_, customerId) => customerId,
  (users, customerId) =>
    users.filter((user) =>
      user.userRoles?.some(
        (role) =>
          // customerId is the scalar; customer the nested object. Queries select
          // one or the other depending on whether the caller may read customers.
          (role.customer?.id ?? role.customerId) === customerId ||
          role.device?.customerId === customerId
      )
    )
);
